// react
import React from 'react';
import styled from 'styled-components';

export const HorizontalSplit = ({
  topContent,
  bottomContent,
}: HorizontalSplitProps) => {
  return (
    <Wrapper>
      <TopContainer>{topContent}</TopContainer>
      <BottomContainer>{bottomContent}</BottomContainer>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const TopContainer = styled.div`
  flex: 1;
  position: relative;
  z-index: 1;
`;

const BottomContainer = styled.div`
  flex: 1;
  position: relative;
`;

interface HorizontalSplitProps {
  topContent?: React.ReactNode;
  bottomContent?: React.ReactNode;
}

HorizontalSplit.displayName = 'HorizontalSplit';

export default HorizontalSplit;
